import { createFileRoute } from '@tanstack/react-router';

import { RolesPage } from '@/features/profiles/company-pages';

export const Route = createFileRoute('/_app/org/$orgId/roles')({ component: OrgRoute });

function OrgRoute() {
  const { orgId } = Route.useParams();
  return <RolesPage orgId={orgId} />;
}
